// import axios from "axios";

// export const apiGet = async (url, params = {}) => {
//   try {
//     const token = getTokenFromLocalStorage();
//     const response = await axios.get(url, {
//       params,
//       headers: {
//         Authorization: `${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const apiPost = async (url, data = {}) => {
//   try {
//     const token = getTokenFromLocalStorage();
//     const response = await axios.post(url, data, {
//       headers: {
//         Authorization: `${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const apiPut = async (url, data = {}) => {
//   const token = getTokenFromLocalStorage();
//   try {
//     const response = await axios.put(url, data, {
//       headers: {
//         Authorization: `${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const apiDelete = async (url) => {
//   const token = getTokenFromLocalStorage();

//   try {
//     const response = await axios.delete(url, {
//       headers: {
//         Authorization: `${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const apiFilePut = async (url, data = {}) => {
//   const token = getTokenFromLocalStorage();

//   try {
//     const response = await axios.put(url, data, {
//       headers: {
//         Authorization: `${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const apiFilePost = async (url, data = {}) => {
//   const token = getTokenFromLocalStorage();

//   try {
//     const response = await axios.post(url, data, {
//       headers: {
//         Authorization: `${token}`,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// const getTokenFromLocalStorage = () => {
//   return localStorage.getItem("JWTtoken");
// };

import axios from "axios";

// ✅ Function to fetch token from localStorage
const getTokenFromLocalStorage = () => {
  return localStorage.getItem("JWTtoken");
};

// ✅ Function to handle token expiration
const handleTokenExpiration = (error) => {
  if (error.response && error.response.status === 403) {
    localStorage.clear();
    window.location.href = "/";
  }
};

// ✅ GET Request
export const apiGet = async (url, params = {}) => {
  try {
    const token = getTokenFromLocalStorage();
    const response = await axios.get(url, {
      params,
      headers: {
        Authorization: `${token}`,
      },
    });
    return response.data;
  } catch (error) {
    handleTokenExpiration(error);
    throw error;
  }
};

// ✅ POST Request
export const apiPost = async (url, data = {}) => {
  try {
    const token = getTokenFromLocalStorage();
    const response = await axios.post(url, data, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return response.data;
  } catch (error) {
    handleTokenExpiration(error);
    throw error;
  }
};

// ✅ PUT Request
export const apiPut = async (url, data = {}) => {
  try {
    const token = getTokenFromLocalStorage();
    const response = await axios.put(url, data, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return response.data;
  } catch (error) {
    handleTokenExpiration(error);
    throw error;
  }
};

// ✅ DELETE Request
export const apiDelete = async (url) => {
  try {
    const token = getTokenFromLocalStorage();
    const response = await axios.delete(url, {
      headers: {
        Authorization: `${token}`,
      },
    });
    return response.data;
  } catch (error) {
    handleTokenExpiration(error);
    throw error;
  }
};

export const apiFilePut = async (url, data = {}) => {
  try {
    const token = getTokenFromLocalStorage();
    const response = await axios.put(url, data, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    handleTokenExpiration(error);
    throw error;
  }
};

export const apiFilePost = async (url, data = {}) => {
  try {
    const token = getTokenFromLocalStorage();
    const response = await axios.post(url, data, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    handleTokenExpiration(error);
    throw error;
  }
};
